import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { DashboardEntity } from './dashboard.entity';
import { PortalSiteEntity } from './portal-site.entity';

/**
 * Portal-site assignment for a `STOREFRONT`-scope dashboard. Many-to-
 * many at the table level: a single dashboard design can serve many
 * portal sites (a tenant with several brand portals can share one
 * design across all of them) and a portal site has at most one
 * dashboard assignment (UNIQUE on `_fk_portal_site__id`).
 *
 * Resolution at storefront load time:
 *   1. Find a row where `_fk_portal_site__id == active portal`.
 *   2. If none, find a STOREFRONT dashboard with no `dashboard_portal_
 *      site` rows (the tenant-default fallback design).
 *   3. If none, render no dashboard.
 *
 * Empty for CRM-scope dashboards.
 */
@Index('idx_dashboard_portal_site_dashboard', ['dashboardId'])
@Index('idx_dashboard_portal_site_portal', ['portalSiteId'], { unique: true })
@Entity('dashboard_portal_site')
export class DashboardPortalSiteEntity extends BaseEntity {
	@Column('int', { name: '_fk_dashboard__id', unsigned: true })
	public dashboardId!: number;

	@Column('int', { name: '_fk_portal_site__id', unsigned: true })
	public portalSiteId!: number;

	@ManyToOne(() => DashboardEntity, (dashboard) => dashboard.portalSiteLinks, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_dashboard__id', referencedColumnName: 'id' }])
	public dashboard!: DashboardEntity;

	@ManyToOne(() => PortalSiteEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_portal_site__id', referencedColumnName: 'id' }])
	public portalSite!: PortalSiteEntity;
}
